import { render, staticRenderFns } from "./CatalogSectionV.vue?vue&type=template&id=b9f72ee0&"
import script from "./CatalogSectionV.vue?vue&type=script&lang=js&"
export * from "./CatalogSectionV.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSectionV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports